'use client' // Error components must be Client components

import NotFound from '@/components/NotFound'
import WithErrorPageLayout from '@/helpers/WithErrorPageLayout'

const PageNotFound = WithErrorPageLayout(NotFound)

export default PageNotFound
